import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IconFacebook,
  IconShipping,
  IconYoutube
} from "../../assets/icons/icons";
import { UserContext } from "../../services/AppContext/appProvider";
// import PWAPromptPopup from "../../components/PWAPrompt/PWAPopup.component";
// import PWAPrompt from "../../components/PWAPrompt/PWAPrompt.component";
import { useOpenTerms } from "../../hooks/useOpenTerms";
import ReportProblemPopup from "../../pages/Contact/reportProblemPopup.component"; // Adjust the path as needed
import { useTheme } from "../../services/ThemeContext";
import { goToFacebook, goToYoutube, scrollToTop } from "../../utilities/utils";
import { FaLock } from "react-icons/fa";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  const { setCurrentPage } = useContext(UserContext);
  const [showNotificationsPermission, setShowNotificationsPermission] =
    useState<boolean>(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  function custNav(url: string) {
    nav(url);
    scrollToTop();
  }

  useEffect(() => {
    try {
      if (Notification.permission === "default") {
        setShowNotificationsPermission(true);
      }
    } catch (error) {
      console.error("Error checking for Notifications Permission", error);
    }
  }, []);

  function allowNotifications() {
    console.log("perm new", Notification.permission);
    try {
      if (!("Notification" in window)) {
        console.log("Browser does not support desktop notification");
      } else {
        if (Notification.permission === "default") {
          Notification.requestPermission();
          setShowNotificationsPermission(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  const openTerms = useOpenTerms();
  const { theme } = useTheme(); // Get the current theme

  return (
    <footer
      className={`footer justify-items-center p-1 lg:mt-1 xl:mt-1 ${theme === "dark" ? "bg-success text-base-100" : "bg-secondary text-white"}`}
    >
      <div className="mt-1 grid grid-cols-1 gap-2 lg:gap-4 xl:grid-cols-5 xl:gap-8">
        <div className="flex w-full flex-col items-center xl:ml-0">
          <div className="mt-2 flex flex-row items-center gap-2 text-sm font-semibold">
            Secured by
            <a
              href="https://www.peachpayments.com/"
              target="_blank"
              className="text-accent"
              rel="noreferrer"
            >
              Peach Payments
            </a>
            <FaLock className="" />
          </div>

          <img
            src={`../../assets/images/LogoIcon.svg`}
            alt="logo"
            className={`mt-4 h-12 rounded-lg border-none hover:bg-transparent xl:mt-12`}
          />
        </div>
        <div className="mt-1 flex w-full flex-col items-center xl:ml-0">
          <IconShipping
            className={`m-auto h-8 w-8 items-center justify-center ${theme === "dark" ? "fill-white" : "fill-white"}`}
          />
          <h4 className="mt-2 justify-center text-center text-lg font-bold lg:w-full xl:w-3/5">
            {t("Free Shipping on all orders")}
          </h4>
        </div>

        <nav className="flex w-full flex-col items-center lg:ps-0 xl:ps-0">
          <h5 className="footer-title text-lg opacity-100">Site Links</h5>
          <div className="grid grid-cols-3 gap-1 xl:grid-cols-1">
            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() => custNav("/")}
            >
              Home
            </button>

            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() => custNav("/winners")}
            >
              Winners
            </button>

            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() => custNav("/about")}
            >
              About Us
            </button>

            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() => custNav("/dashboard")}
            >
              My Account
            </button>

            <button
              className="col-span-2 py-[2px] transition-all hover:text-neutral-800 xl:col-span-1"
              onClick={() => {
                setCurrentPage("terms-and-conditions");
                openTerms();
              }}
            >
              Terms and Conditions
            </button>

            {/* <button
            className=" py-2 hover:text-neutral-800 transition-all text-left"
            onClick={openPopup}
          >
            Report a Problem
          </button> */}
          </div>
        </nav>

        <nav className="flex w-full flex-col items-center lg:ps-0 xl:ps-0">
          <h5 className="footer-title text-lg opacity-100">Help</h5>

          <div className="grid grid-cols-3 gap-2 xl:grid-cols-1 xl:gap-0">
            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() =>
                nav("/guide", { state: { ...location.state, scrollTo: "faq" } })
              }
            >
              FAQ
            </button>

            <button
              className="py-[2px] transition-all hover:text-neutral-800"
              onClick={() => custNav("/buy-packs")}
            >
              Buy Bids
            </button>
          </div>
        </nav>

        <div className="mb-1 mt-1 flex w-full flex-col items-center lg:mb-0 lg:mt-0 lg:ps-0 xl:mb-0 xl:mt-0 xl:w-auto xl:items-start xl:ps-0">
          <div className="flex flex-row items-center gap-2 align-middle xl:flex-col">
            {showNotificationsPermission && (
              <button
                className="btn-white btn btn-sm w-1/2 rounded-3xl border-none leading-4 text-secondary xl:w-full"
                onClick={() => allowNotifications()}
              >
                {t("Allow Notifications")}
              </button>
            )}
            <button
              className={`btn-white btn btn-sm ${showNotificationsPermission ? "w-1.2" : "w-full"} rounded-3xl border-none text-secondary xl:w-full`}
              onClick={() => custNav("/contact-us")}
            >
              Contact Support
            </button>
          </div>
          {/* social media icons */}

          <div className="mt-2 flex w-full items-center justify-center gap-4 self-center xl:ml-1 xl:mt-4 xl:justify-start">
            <IconFacebook
              className={`link h-8 w-8 fill-base-100 transition-all ${theme === "dark" ? "fill-white" : "fill-white"}`}
              // onClick={goToFacebook}
            />
            <IconYoutube
              className={`link h-10 w-10 fill-base-100 transition-all ${theme === "dark" ? "fill-white" : "fill-white"}`}
              // onClick={goToYoutube}
            />
            {/* <IconInstagram className="link h-8 w-8 fill-base-100" />
            <IconTwitter className="link h-8 w-8 fill-base-100" /> */}
          </div>

          {/* <PWAPrompt />
          <PWAPromptPopup /> */}
        </div>
      </div>
      {isPopupOpen && <ReportProblemPopup onClose={closePopup} />}
    </footer>
  );
};

export default Footer;
